<div class="onboarding-card" [class]="envClass">
  <div class="onboarding-header">
    <div class="logo-preview">
      <i class="material-icons">event_note</i>
      <strong>Your</strong>Notes
    </div>
  </div>
  
  <div class="onboarding-body">
    <h2>Welcome to YourNotes!</h2>
    <p>
      Get more out of YourNotes by connecting your calendar.
    </p>
    
    <div class="setup-illustration">
      <i class="material-icons">sync_alt</i>
    </div>
    
    <p class="sub-text">
      Sync your Google, Outlook and iCloud calendars to see your meetings, tasks and upcoming events 
in one place. You can also continue without a calendar and connect one later at any time.

    </p>
  </div>

  <div class="onboarding-footer">
    <button class="btn-wizard" [mat-dialog-close]="true">
      Connect calendar (recommended)
      <i class="material-icons">chevron_right</i>
    </button>
    <button class="btn-skip" [mat-dialog-close]="false">Continue without calendar</button>

    <!-- NIEUW: Vinkje links onderaan -->
    <div class="footer-bottom-left">
      <label class="checkbox-label">
        <input 
          type="checkbox" 
          [(ngModel)]="settings.showWelcomePopup"
          (change)="onShowWelcomePopup($event)">
        <span>Show welcome popup</span>
      </label>
    </div>
  </div>
</div>